import { render, staticRenderFns } from "./createUser2.vue?vue&type=template&id=6569a5cf&scoped=true&"
import script from "./createUser2.vue?vue&type=script&lang=js&"
export * from "./createUser2.vue?vue&type=script&lang=js&"
import style0 from "./createUser2.vue?vue&type=style&index=0&id=6569a5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569a5cf",
  null
  
)

export default component.exports